import { NAV_LINKS } from '@/config/navigation'
import { Link, usePathname } from '@/i18n/navigation'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'

export function MainMenu() {
  const t = useTranslations('Navigation')
  const pathname = usePathname()

  return (
    <nav aria-label="Main Navigation">
      <ul className="mx-auto flex">
        {NAV_LINKS.map((link) => (
          <li
            key={link.label}
            className="text-body-3 px-2 py-2.5 leading-6 transition-all"
          >
            <Link
              className={cn(
                'hover:text-primary-400 text-primary-500 relative inline-block',
                'after:bg-secondary-500 after:absolute after:-bottom-[10.5px] after:left-0 after:h-0.5 after:w-0 after:rounded-2xl after:transition-all after:duration-300 after:ease-linear after:content-[""]',
                'hover:after:w-full',
                pathname === link.href
                  ? 'font-bold after:w-full'
                  : 'text-primary-500'
              )}
              href={link.href}
            >
              {t(link.label)}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}
